const r = {
  Home: "HOME",
  Mobile: "MOBILE",
  Business: "BUSINESS"
};
function i(e) {
  return n(e);
}
function n(e, o) {
  return e;
}
function t(e) {
  return e;
}
export {
  r as PhoneType,
  i as PhoneTypeFromJSON,
  n as PhoneTypeFromJSONTyped,
  t as PhoneTypeToJSON
};
//# sourceMappingURL=PhoneType.js.map
